import React from "react";
import { SquareX, Square, ClockIcon } from "lucide-react";

interface Todo {
  content: string;
  status: "pending" | "in_progress" | "completed";
  id?: string;
}

interface TodoListBlockProps {
  todos: Todo[];
  status: "in-progress" | "succeeded" | "failed" | "aborted";
}

const getStatusIcon = (todoStatus: string) => {
  switch (todoStatus) {
    case "completed":
      return <SquareX className="w-3 h-3 text-secondary-n-400 shrink-0" />;
    case "in_progress":
      return <ClockIcon className="w-3 h-3 text-secondary-n-400 shrink-0" />;
    case "pending":
      return <Square className="w-3 h-3 text-secondary-n-400 shrink-0" />;
    default:
      return <Square className="w-3 h-3 text-secondary-n-400 shrink-0" />;
  }
};

export const TodoListBlock: React.FC<TodoListBlockProps> = ({
  todos,
  status,
}) => {
  if (todos.length === 0) {
    return (
      <span className="text-xs text-secondary-n-500">No todos available</span>
    );
  }

  return (
    <div className="space-y-2 mt-1">
      {todos.map((todo, index) => (
        <div key={todo.id || index} className="flex gap-2">
          <div className="flex items-center h-4">
            {getStatusIcon(todo.status)}
          </div>
          <div className="text-xs text-secondary-n-400 font-medium leading-4">
            {todo.content}
          </div>
        </div>
      ))}
    </div>
  );
};
